export type BlobObjectData = {
	idOrUrl: string;
	size: number;
	expiresAt?: Date;
	createdAt?: Date;
};
